import { AbstractModel, JsonObject, JsonProperty } from 'projects/core/src/public-api';
import { ResponcePage } from 'projects/core/src/lib/misc/data/responce-page';
import { CabinetReport } from 'projects/app-misc/src/app/modules/reports/data/cabinet-report';
import { ShortProject } from 'projects/app-misc/src/app/modules/project-misc/data/project/short-project';
import {
  CabinetComplexityVariation
} from 'projects/app-misc/src/app/modules/reports/data/cabinet-complexity-variation';

@JsonObject('CabinetsComplexityPage')
export class CabinetsComplexityPage extends ResponcePage {

  @JsonProperty([CabinetComplexityVariation], 'content')
  content: CabinetComplexityVariation[];
}
